import { Grid, IconButton, List, ListItem } from "@mui/material";
import { Avatar, Box, Typography } from "@maysoft/common-component-react";

import useStrings from "../../hooks/useStrings";

import { CloseIcon } from "../../assets/icon/svg";
import { IUserComment } from "../../commons/interfaces";
import { RemoveOverflowYDrawer } from "../CommunityCommonLayout";
import { getNameRoleCommunity } from "../CommunityPost/itemDetailPostComment";


const PopupUser = (props: {
    openDrawer: boolean;
    dataUser: IUserComment;
    onCloseDrawer: () => void;
}) => {
    const Strings = useStrings();

    return (
        <RemoveOverflowYDrawer
            anchor="right"
            open={props.openDrawer}
            onClose={props.onCloseDrawer}
        >
            <Grid sx={{
                width: "300px",
                display: "flex",
                minHeight: "100%",
                flexDirection: "column",
                justifyContent: "space-between",
            }}>
                <List>
                    <ListItem sx={{
                        display: "flex", justifyContent: "end",
                        padding: "0px", paddingRight: "8px",
                    }}>
                        <IconButton onClick={() => { props.onCloseDrawer() }}>
                            <CloseIcon />
                        </IconButton>
                    </ListItem>
                    <ListItem>
                        <Box>
                            <Avatar
                                src={props.dataUser?.avatarUrl}
                                style={{ width: "150px", height: "150px" }}
                                text={props.dataUser?.fullName || props.dataUser?.userName}
                            />
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Typography variant="h3" fontWeight="medium">
                            {props.dataUser?.fullName}
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <Box display="flex" alignItems="end">
                            <Typography variant="button">
                                {Strings.CHANNEL.COMMUNITY_ROLE}:
                            </Typography>
                            <Typography sx={{ ml: 2 }} variant="button" color="info" fontWeight="bold">
                                {getNameRoleCommunity(props.dataUser?.role || 0)}
                            </Typography>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Typography variant="h6" fontWeight="medium">
                            {Strings.CHANNEL.PAST_ACTIVITY}
                        </Typography>
                    </ListItem>
                </List>
            </Grid>
        </RemoveOverflowYDrawer>
    );
}

export default PopupUser;